.micro {
  font: var(--micro-default-font);
  letter-spacing: var(--micro-default-letter-spacing);
}
